import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "select-month" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Escolha o mês:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_StructureTenantCard = _resolveComponent("StructureTenantCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Sensores por Tenant" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Datepicker, {
          class: "date-picker",
          placeholder: "Escolha o mês",
          "minimum-view": "month",
          "maximum-view": "month",
          format: " MMMM/yyyy",
          language: "pt",
          onChangedMonth: _ctx.handleChangedMonth,
          value: _ctx.selectedDate
        }, null, 8, ["onChangedMonth", "value"])
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenants, (tenant) => {
          return (_openBlock(), _createBlock(_component_StructureTenantCard, {
            key: tenant.id,
            tenant: tenant,
            sensors: _ctx.sensorsCount(tenant.id).value,
            billings: _ctx.billings?.filter(billing => billing.tenant == tenant.id) || [],
            monthDate: _ctx.selectedDate
          }, null, 8, ["tenant", "sensors", "billings", "monthDate"]))
        }), 128))
      ])
    ])
  ], 64))
}